import { useState, useEffect } from 'react'
import { siteAPI, uploadFile } from '../services/api'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage, getImageUrl } from '../utils/helpers'

const Offers = () => {
  const { showSuccess, showError } = useNotification()
  const [settings, setSettings] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    try {
      const response = await siteAPI.getSettings()
      setSettings(response.data.settings || {})
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    
    try {
      const data = {
        offer_title: formData.get('offer_title'),
        offer_text: formData.get('offer_text'),
      }
      await siteAPI.updateSettings(data)
      showSuccess('Offer updated.')
      fetchSettings()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  const handleImageUpload = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const imageFile = formData.get('image')
    const remove = formData.get('remove') === '1'

    try {
      if (remove) {
        await siteAPI.updateSettings({ offer_image: '' })
        showSuccess('Offer image removed.')
      } else if (imageFile && imageFile.size > 0) {
        const uploadRes = await uploadFile(imageFile)
        const uploadedImg = uploadRes.data.filename || uploadRes.data.image
        await siteAPI.updateSettings({ offer_image: uploadedImg })
        showSuccess('Offer image updated.')
      } else {
        showError('Choose an image file to upload.')
        return
      }
      fetchSettings()
      e.target.reset()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  if (loading) return <div className="admin-page">Loading...</div>

  return (
    <div className="admin-page">
      <h2 className="admin-title">Offers</h2>
      <p className="admin-sub">Manage promotional offers displayed on your website.</p>

      <div className="row">
        <div className="col-lg-8">
          <div className="panel">
            <div className="panel-head">Offer Content</div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Offer Title</label>
                <input type="text" name="offer_title" className="form-control" defaultValue={settings.offer_title} />
              </div>
              <div className="form-group">
                <label>Offer Text</label>
                <textarea name="offer_text" className="form-control" rows="4" defaultValue={settings.offer_text}></textarea>
              </div>
              <button className="btn btn-gold btn-block">Update Offer</button>
            </form>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="panel">
            <div className="panel-head">Offer Image</div>
            {settings.offer_image && (
              <div className="file-preview">
                <span>Current offer image</span>
                <img src={getImageUrl(settings.offer_image)} alt="Offer" />
              </div>
            )}
            <form onSubmit={handleImageUpload}>
              <div className="form-group">
                <input type="file" name="image" className="form-control-file" accept="image/*" />
              </div>
              {settings.offer_image && (
                <label className="checkbox-inline">
                  <input type="checkbox" name="remove" value="1" /> Remove current image
                </label>
              )}
              <button className="btn btn-gold btn-sm mt-2">
                <i className="fa fa-cloud-upload"></i> Upload Image
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Offers
